module.exports = __webpack_public_path__ + "static/media/modalInfo.4f68e420.svg";